import countries from 'i18n-iso-countries'
import enLocale from 'i18n-iso-countries/langs/en.json'

// 注册语言
countries.registerLocale(enLocale)

// 国家代码 → Emoji
export function countryNameToEmoji(name: string) {
  const countryCode = countries.getAlpha2Code(name, 'en') // SG

  if (!countryCode) return ''
  return countryCode
    .toUpperCase()
    .replace(/./g, (c) => String.fromCodePoint(c.charCodeAt(0) + 127397))
}
